import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {TestConfiguration} from '../../interfaces/test-configuration.interface';
import * as _ from 'lodash';
import {find, findIndex, get, has, isEmpty} from 'lodash';
import {IDiagnosticOrder, IRevision} from '../../interfaces/diagnostic-order.interface';
import {CoreActionCreatorService} from '@ispm/core/services/core-action-creator.service';
import {Store} from '@ngrx/store';
import {Observable, Subject} from 'rxjs';
import {IWorkflowJobItem} from '@ispm/workflow/interfaces/job-item.interface';
import {testViewWithPatientProfile} from '@ispm/test/routes/test-view-state-names';
import {IWorkflow} from "@ispm/core/interfaces/workflow.interface";
import { filter, takeUntil, tap } from 'rxjs/operators';
import {ReviseService} from "@ispm/workflow/services/revise.service";
import {TestRunningMode} from "@ispm/test/interfaces/test-running-mode.enum";
import {PatientInfoService} from '@ispm/user/services/patientInfo.service';
import {ReadOnlyParameters} from "@ispm/test/interfaces/read-only-parameters";
import * as jsonPath from 'jsonpath';
import {
  FetchCurrentPatientSimilarDataAction,
  selectCurrentPatientData,
  SimilarPatientsDataState
} from '@ispm-client/modules/similar-patients/store';
import {FormHandlerService} from '@ispm/shared/dynamic-form/services/form-handler.service';
import {AgregationService} from '@ispm-client/modules/aggregator/services';
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
import {PathwayConfirmStepService} from '@ispm-client/modules/pathways/services/pathway-confirm-step.service';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {ReassignTestModalComponent} from '@ispm/layout/components/modals/reassign-test-modal/reassign-test-modal.component';
import {ModalTypes} from '@ispm/layout/components/modals/contants/modal-types.enum';
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {ReassignModalService} from '@ispm/layout/services/reassign-modal.service';
import { TestService } from '../../services/test.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {PollJobService} from "@ispm/test/services/poll-job.service";
import { AttachmentService } from '@ispm/migration/services/attachment.service';
import { NotesService } from '@ispm/user/services/notes.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { AllOrdersService } from '../../services/all-orders.service';
import {Router} from "@angular/router";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {PermissionSchemaConstants} from "@ispm/shared/constants/permission-schema.constants";
import {DocumentsTabService} from "@ispm/test/services/documents-tab.service";
import {TestBarActionInterface} from '@ispm/test/components/test-bar/test-bar-action.interface';
import {tooltipPositions} from '@ispm/shared/directives/tooltips/tooltip.directive';

export const TEST_ID_PATH = 'patientAnalyses.current.identifiers[0].value';
export const CONFIRM_BUTTON = 'confirmButton';

@Component({
  selector: 'gen-test-bar',
  templateUrl: './test-bar.component.html',
  styleUrls: ['./test-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestBarComponent implements OnInit, OnDestroy, AfterViewInit  {
  @Input() currentTest: IDiagnosticOrder;
  @Input() currentWorkflow: IWorkflow;
  @Input() currentRevision: IRevision;
  @Input() customRevisionData: any;
  @Input() showOldWorkflowBar: boolean;
  @Input() newNotes: number;
  @Input() contextName: string;
  @Input() showRevise: boolean;
  @Input() latestRevisionId: string;
  @Input() testInWorklist: boolean;
  @Input() infoOrigin: any;
  @Input() stepTaglineField: any;
  @Input() patientAnalyses: any;
  @Input() isCustomConfig: any;
  @Input() isPatientEditable: any;
  @Input() isAttachmentEnabled: boolean;
  @Output() notesPanelOpened : EventEmitter<any> = new EventEmitter();

  public testConfiguration: TestConfiguration;
  public reviseTemplates: Array<{ usage: 'revision' | 'test', reference: string }>;
  public isPerformer: boolean = false;
  public isAdmin: boolean = false;
  public isArchived: boolean = false;
  public headerInfo: Array<{ name: string, values: any[], cssClass?: string, cssClassAvailable: boolean, addRevision?: boolean }> = [];
  public testActions: Array<TestBarActionInterface> = [];
  public testActionsPresent: boolean = false;
  public flattenHeaders: boolean = false;
  public showTestDescription: boolean = true;
  public showInfo: boolean = false;
  public revisionId: string;
  public workflowID: string;
  public hideBackActionButton: boolean = false;
  public testIsCompleted: boolean = false;
  public testInDraftMode: boolean = false;
  public readOnlyParameters: ReadOnlyParameters;
  public stopActionItem: TestBarActionInterface;
  public manageTagsActionItem: TestBarActionInterface;
  public changeManagingFacilityActionItem: TestBarActionInterface;
  public stepTagLine: any;
  public activeJobItem: IWorkflowJobItem;
  public setIsDisabledRevise$: Observable<boolean>;
  public isBackDisabled: boolean;
  public backActionButtonPermitted: boolean = false;

  protected readonly toolTipPositions = tooltipPositions;

  private destroyer$: Subject<void> = new Subject();
  private documentPreviewLoadedEventSubscription: any;

  constructor(
    private testService: TestService,
    private pollJobService: PollJobService,
    private attachmentsService: AttachmentService,
    private notesService: NotesService,
    private authService: AuthenticationService,
    private workflowService: WorkflowService,
    private notificationMessageService: NotificationMessageService,
    private coreActionCreator: CoreActionCreatorService,
    private router: Router,
    private routerManagerService: RouterManagerService,
    private agregationService: AgregationService,
    private changeDetector: ChangeDetectorRef,
    private similarPatientDataStore$: Store<SimilarPatientsDataState>,
    private patientInfoService: PatientInfoService,
    private formHandler: FormHandlerService,
    private ispmHttpClient: IspmHttpClient,
    private pathwayConfirmStepService: PathwayConfirmStepService,
    private modalLoaderService: DynamicModalLoaderService,
    private userActionCreatorService: UserActionCreatorService,
    private reassignModalService: ReassignModalService,
    private allOrdersService: AllOrdersService,
    private documentsTabService: DocumentsTabService
  ) {
  }

  ngOnInit() {
    this.revisionId = this.routerManagerService.parameters?.revisionId;
    this.workflowID = this.routerManagerService.parameters?.workflowId;
    this.testConfiguration = this.testService.testConfiguration;
    this.isAdmin = this.authService.user.isAdmin;
    this.isArchived = this.patientAnalyses?.current?.workflowRequest.hasOwnProperty("activeWorkflow")
      ? !this.patientAnalyses.current.workflowRequest.activeWorkflow
      : false;
    this.pathwayConfirmStepService.getWorkflowStepActionOverride().pipe(
      takeUntil(this.destroyer$.asObservable()),
      tap(workflowAction => {
        this.hideBackActionButton = get(workflowAction, 'hideBackActionButton', false);
        this.changeDetector.markForCheck();
      })
    ).subscribe();

    this.backActionButtonPermitted = this.authService.doesUserHasPermission(PermissionSchemaConstants.schemaWorkflowBackAction);

    this.buildInfo();
    this.isPerformer = this.pathwayConfirmStepService.checkIfUserCanPerformStep(this.currentWorkflow);
    this.validReviseStep();
    this.setShowTestDescription();
    this.setReadOnlyModeParameters();

    this.activeJobItem = this.pathwayConfirmStepService.getStepActiveJobItem(this.currentWorkflow, this.currentRevision);
    this.testIsCompleted = this.currentTest.workflowRequest.status.toLowerCase() === 'done';
    this.testInDraftMode = this.currentTest.runningMode === TestRunningMode.DRAFT_MODE;
    this.stepTagLine = get(this.testConfiguration, 'stepTaglineField', undefined);
    this.isBackDisabled = this.currentWorkflow.activeJobName === "documentsPreview";

    this.documentPreviewLoadedEventSubscription = this.documentsTabService.documentPreviewLoadedEvent.subscribe(() => {
      //Add a delay for completion all the background processes before the 'Back' action availability (GEN-197647)
      setTimeout(() => {
        this.isBackDisabled = false;
        this.changeDetector.markForCheck();
      }, 1000)
    });
  }

  ngAfterViewInit() {
    this.setIsDisabledRevise$ = this.allOrdersService.validateActionDisableState(this.currentWorkflow);
  }

  private fetchSimilarPatientData() {
    this.similarPatientDataStore$.dispatch(
      new FetchCurrentPatientSimilarDataAction({patientId: this.routerManagerService.parameters.patientId})
    );
  }

  setReadOnlyModeParameters() {
    if (this.testConfiguration && this.testConfiguration.readOnlyMode) {
      const readOnlyDesc = this.testConfiguration.readOnlyMode;
      this.readOnlyParameters = this.reassignModalService.setReadOnlyModeParameters(readOnlyDesc, this.currentTest,this.authService.user);
    }
  }

  validReviseStep() {
    if (this.isPerformer && ReviseService.isReviseDefinitionAvailable(this.testConfiguration, this.currentWorkflow, this.currentRevision)) {
      this.setReviseTemplates();
    }
  }

  setShowTestDescription() {
    if (this.currentTest.runningMode && this.currentTest.runningMode != TestRunningMode.REGULAR_MODE) {
      const runningModeData = this.currentTest.runningMode.toLowerCase() + 'ModeData.testBar.showTestDescription';

      if (has(this.testConfiguration, runningModeData)) {
        this.showTestDescription = get(this.testConfiguration, runningModeData, true);
      }
    } else {
      this.showTestDescription = get(this.testConfiguration, 'showTestDescription', true);
    }
  }

  setReviseTemplates() {
    this.reviseTemplates = this.testConfiguration.workflowJobsTemplates.reduce((arr, item) => {
      if (item.usage === 'revision') {
        arr.push(item);
      }

      return arr;
    }, []);
  }

  goToRevision(workflowID: string, revisionID: string): void {
    const navigationParams = {
      patientId: this.routerManagerService.parameters.patientId,
      testId: workflowID,
      revisionId: revisionID
    };
    const queryParams = {
      EMRIntegration: this.routerManagerService.queryParameters?.EMRIntegration
    }
    const navigationOptions = {
      fragment: this.routerManagerService.fragments,
      skipLocationChange: true
    }
    const navigateTo = testViewWithPatientProfile + '/' + navigationParams.patientId + '/' + navigationParams.testId + '/' + navigationParams.revisionId;

    this.pollJobService.pollingUntilStepAndNavigate(revisionID, workflowID, this.testConfiguration, navigateTo, queryParams, navigationOptions);
  }

  toggleNotes(): void {
    this.notesService.toggleNotes(this.editModeIsSupported());
    this.notesPanelOpened.emit(true);
  }

  toggleAttachments(): void {
    this.attachmentsService.toggleAttachments(this.editModeIsSupported());
  }

  collapseNotes(): void {
    this.notesService.collapseNotes();
  }

  collapseAttachments(): void {
    this.attachmentsService.collapseAttachments();
  }

  reassign(): void {
    const practitionerFilterBy = get(this.readOnlyParameters, 'practitionerFilterBy', undefined);
    const tempAnalysis = {
      activeRevision: this.routerManagerService.parameters.revisionId,
      workflowrequest_id: this.routerManagerService.parameters.testId,
      practitionerFilterBy: practitionerFilterBy
    };
    let allowedRolesForReassignment: any;

    this.userActionCreatorService.getStoredOrganizationConfiguration()
      .take(1)
      .map((organization) => {
        allowedRolesForReassignment = organization.allowedRolesForReassignment ? organization.allowedRolesForReassignment : ['Pathologist'];
      })
      .toPromise();

    let modalPayload: any = {};
    modalPayload.name = this.contextName;
    modalPayload.testNumber = this.currentTest.identifiers[0].value;
    modalPayload.analysis = tempAnalysis;
    modalPayload.practitionerRoles = allowedRolesForReassignment;
    modalPayload.enableReassign = allowedRolesForReassignment !== null ?
    !!(allowedRolesForReassignment.find((role: string) => role.toLocaleLowerCase() === this.authService.getUser().role.toLocaleLowerCase())) : true;
    modalPayload.practitionerFilterBy = modalPayload.analysis.practitionerFilterBy;
    modalPayload.disallowedPractitionerRoles = ['Provider'];
    modalPayload.modalName = 'ReassignTest';
    modalPayload.title = modalPayload.name + ', Item No. ' + modalPayload.testNumber;

    this.modalLoaderService.popupModal(
      ReassignTestModalComponent,
      {
        content: modalPayload,
        backdropAllowed: false
      }, ModalTypes.NONE
    )
      .subscribe(
        (data) => {
          if (data && data.payload && data.payload.action === 'close') {
            this.routerManagerService.reload('', {reload: true}); // we need to reload, otherwise resolves won't trigger
          }
        }
      );
  }

  export(testAction: any): void {
    this.notificationMessageService.info("Export data for Therapy System started.");

    if (has(testAction, "payload.dataBinding")) {
      let dataBindings = [];

      testAction.payload.dataBinding.forEach((currentBinding: any) => {
        dataBindings.push(currentBinding);
      })

      this.agregationService.registerQuery(dataBindings).take(1)
        .subscribe(
          (bundleResults: any) => {
            let value = jsonPath.value(bundleResults[0],dataBindings[0].valueExpression);
            const payLoad = {"studyId": value};

            this.ispmHttpClient.get("EDAP/export",payLoad, false, {}, {responseType: 'arraybuffer'})
              .subscribe(
                (response) => {
                  this.responseToZip(response, value);
                  this.notificationMessageService.info("Export data for Therapy System completed .");
                },
                () => {
                  this.notificationMessageService.info("Therapy System Download Failed.");
                }
              );
        }
      );
    }
  }

  private responseToZip(data: any, exportTitle: string) {
    const blob = new Blob([data], { type: "application/zip" });
    const url = window.URL ;
    const link = url.createObjectURL(blob);
    const element = document.createElement("a");

    element.download = exportTitle+".zip";
    element.href = link;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  removeFromWorklist(): void {
    let modalPayload: any = {};
    modalPayload.modalName = 'ReamoveModal';
    modalPayload.title = 'Remove test from worklist';

    this.modalLoaderService.popupModal(
      ReassignTestModalComponent,
      {
        content: modalPayload,
        backdropAllowed: false
      },
      ModalTypes.NONE
    ).subscribe(
      (data) => {
        if (data && data.payload && data.payload.action === 'ok') {
          this.coreActionCreator.setLoader(true);
          this.workflowService.getWorklfowById(this.routerManagerService.parameters.testId)
            .then((workflowResult) => {
              return this.workflowService.removeAnalysisFromWorklist(
                workflowResult.body,
                this.routerManagerService.parameters.revisionId,
                this.authService.user.info.id
              )
                .subscribe(() => {
                  this.notificationMessageService.success('Test removed from your worklist successfully!');
                  this.router.navigate([`Pathologist`], undefined);
                });
            })
            .catch(() => {
                this.notificationMessageService.error('error while removing test from worklist');
            })
            .finally(() => {
                this.coreActionCreator.setLoader(false);
            });
        }
      }
    );
  }

  trackByIndex(index: number): number {
    return index;
  }

  private buildInfo(): void {
    if (this.testConfiguration && this.testConfiguration.headerInfoFields) {
      for (const info of this.testConfiguration.headerInfoFields) {
        let cssClassPresent = false;
        let cssClass;
        let infoAsObject: boolean = false;
        let addRevision: boolean = false;

        if (typeof info === "object") {
            infoAsObject = true;
        }

        if (infoAsObject) {
          const infoObject = info as Object;

          if (has(infoObject, 'cssClass')) {
            cssClassPresent = true;
            cssClass = get(infoObject, 'cssClass');
          }

          let headerValue = {};

          if (has(infoObject, 'pathToValue')) {
            headerValue = this.getPropertyValueByPath(this.infoOrigin, get(infoObject, 'pathToValue'));

            if (get(infoObject, 'pathToValue') === TEST_ID_PATH) {
              addRevision = true;
            }
          } else {
            headerValue = get(infoObject, 'value');
          }

          const row = {name: get(infoObject, 'label'), values: [], cssClassAvailable: cssClassPresent, cssClass, addRevision};

          if (Array.isArray(headerValue)) {
            row.values.concat(headerValue);
          } else {
            row.values.push(headerValue);
          }

          this.headerInfo.push(row);
        } else {
          const headerValue = this.getPropertyValueByPath(this.infoOrigin, info);
          const row = {name: info, values: [], cssClassAvailable: false, addRevision: (info === TEST_ID_PATH)};

          if (Array.isArray(headerValue)) {
            for (let val of headerValue) {
              row.values.push(val);
            }
          } else {
            row.values.push(headerValue);
          }

          this.headerInfo.push(row);
        }
      }
    } else {
      const name = TEST_ID_PATH;
      this.headerInfo.push({
        name: name,
        values: [_.get(this.infoOrigin, name)],
        cssClassAvailable: false,
        addRevision: true
      });
    }

    if (this.testConfiguration && this.testConfiguration.flattenHeaders) {
      this.flattenHeaders = true;
    }

    if (this.testConfiguration) {
      this.readActions(this.testConfiguration.testActions, this.testActions);
      this.testActionsPresent = this.testActions.length > 0;
    }

    this.getManageFacilityAction();

    if (this.testActionsPresent) {
      this.stopActionItem = find(this.testActions, (actionObj: any) => actionObj.action.toLowerCase() === 'stop');
      this.manageTagsActionItem = find(this.testActions, (actionObj: any) => actionObj.action.toLowerCase() === 'managetags');
    } else {
      const stopAction = get(this.testConfiguration, 'stopAction');
      const manageTagsActionItem = get(this.testConfiguration, 'manageTags');

      if (!isEmpty(stopAction)) {
        this.stopActionItem = stopAction;
      }

      if (!isEmpty(manageTagsActionItem)) {
        this.manageTagsActionItem = manageTagsActionItem;
      }
    }

    if (isEmpty(this.stopActionItem)) {
      this.stopActionItem = {
        label : 'Stop Workflow',
        labelAvailable: true,
        action : 'stop',
        icon : '',
        actionIconAvailable: false,
        enable : true,
        permissionId : '',
        primary : false ,
        redirectUrl: ''
      };

      if (this.testActionsPresent) {
        this.testActions.push(this.stopActionItem);
      }
    }

    if (isEmpty(this.manageTagsActionItem)) {
      this.manageTagsActionItem = {
        label: 'Manage tags',
        action: 'manageTags',
        enable: true,
        payload: {
          formId: 'MANAGE-TAGS-POPUP',
          titleText: 'Manage tags',
          cancelButtonText: 'Cancel',
          submitButtonText: 'Confirm'
        }
      };

      if (this.testActionsPresent) {
        this.testActions.push(this.manageTagsActionItem);
      }
    }
  }

  private getManageFacilityAction(): void {
    if (this.testActionsPresent) {
      this.changeManagingFacilityActionItem = find(this.testActions, actionObj =>  actionObj.action.toLowerCase() === 'change_facility');

      if (isEmpty(this.changeManagingFacilityActionItem)) {
        this.changeManagingFacilityActionItem = {
          label : 'Edit Managing Facility',
          labelAvailable: true,
          action : 'change_facility',
          icon : '',
          actionIconAvailable: false,
          enable : true,
          permissionId : '',
          primary : false ,
          redirectUrl: ''
        };

        const stopIndex = findIndex(this.testActions, (actionObj: TestBarActionInterface) =>  actionObj.action.toLowerCase() === 'stop');

        if (stopIndex === -1) {
          this.testActions.push(this.changeManagingFacilityActionItem);
        } else {
          this.testActions.splice(stopIndex, 0, this.changeManagingFacilityActionItem);
        }
      }
    }
  }

  canChangeManagingFacility(): boolean {
    return get(this.changeManagingFacilityActionItem, 'enable', false);
  }

  private readActions(actions: Array<TestBarActionInterface>, outArray: Array<TestBarActionInterface>, parentAction?: TestBarActionInterface) {
    if (! actions || actions.length == 0) {
      return;
    }

    for (const action of actions) {
      let actionIconPresent: boolean = false;
      let labelPresent: boolean = false;

      if (action.icon) {
        actionIconPresent = true;
      }

      if (action.label) {
        labelPresent = true;
      }

      let enable = true;

      if (has(action, 'enable')) {
        enable = get(action, 'enable');
      }

      let subActionsArray: Array<any>;

      if (action.type && action.type.toLowerCase() == "dropdownmenu") {
        action.isDropDownMenu = true;
        subActionsArray = [];

        this.readActions(action.actionList, subActionsArray, action);
      }

      if (parentAction && parentAction.isDropDownMenu == true) {
        if (typeof(action.action) == "string") {
          let menuActionFunc = this.factorDropDownMenuAction(action.action);

          if (menuActionFunc) {
            action.action = menuActionFunc.bind(this);
          }
        }
      }

      const actionObj: TestBarActionInterface = {
        label: action.label, labelAvailable: labelPresent, action: action.action,
        icon: action.icon, actionIconAvailable: actionIconPresent, enable: enable,
        permissionId: action.permissionId, primary: action.primary, actionList: subActionsArray,
        payload: action.payload, redirectUrl: action.redirectUrl
      };

      if (action.permissionId === 'OI.PATIENT.ANALYTICS.READ' && action.enable) {
        actionObj.enable = false;
        outArray.push(actionObj);

        this.getCurrentPatientSimilarData(action.enable);
        this.agregationService.formUpdatedNotification$.pipe(
          takeUntil(this.destroyer$.asObservable()),
          tap(() => this.fetchSimilarPatientData()),
        )
        .subscribe();
      } else {
        outArray.push(actionObj);
      }
    }
  }

  //TODO: Find good place for this utility function.
  private getPropertyValueByPath(obj: any, propName: string): any {
    const path = propName.split('.');
    let current = obj;

    while (path.length > 0) {
      let currentPath = path.shift();

      if (currentPath.indexOf('[') >= 0) {
        const indexMatch = /\[([\d*]+)]/g.exec(currentPath);
        const index = parseInt(indexMatch[1]);
        currentPath = currentPath.replace(indexMatch[0], '');

        if (!isNaN(index)) {
          current = current[currentPath] ? current[currentPath][index] : undefined;
        } else {
          const temp = [];

          for (const sub of current[currentPath]) {
              temp.push(this.getPropertyValueByPath(sub, path.join('.')));
          }

          return temp;
        }
      } else {
        current = current ? current[currentPath] : undefined;
      }
    }

    return current;
  }

  protected editModeIsSupported(): boolean {
    if (this.readOnlyParameters !== undefined) {
      return this.isPerformer;
    }

    return true;
  }

  hideRemoveFromWorklist(): boolean {
    return get(this.testConfiguration, 'hideRemoveFromWorklist', false);
  }

  ngOnDestroy(): void {
    if (this.documentPreviewLoadedEventSubscription) {
      this.documentPreviewLoadedEventSubscription.unsubscribe();
    }

    this.destroyer$.next();
    this.destroyer$.complete();
  }

  protected getUserDisplayName(): string {
    if (this.currentRevision) {
      return this.currentRevision.userDisplayName ? this.currentRevision.userDisplayName : this.currentRevision.name;
    }

    return null;
  }

  patientDetails(){
    this.patientInfoService.openPatientInfo(this.routerManagerService.parameters.patientId).subscribe(res=>{
      console.log(res);
    });
  }

  private getCurrentPatientSimilarData(isActionEnable: boolean) {
    this.fetchSimilarPatientData();
    this.similarPatientDataStore$.select(selectCurrentPatientData)
      .pipe(
        filter(resp => !!resp),
        takeUntil(this.destroyer$.asObservable())
      )
      .subscribe(() => {
        this.setPatientAnalyticsBtnActivity(isActionEnable);
        this.changeDetector.detectChanges();
      });
  }

  private setPatientAnalyticsBtnActivity(isActionEnable: boolean) {
    for (const mainAction of this.testActions) {
      if (Array.isArray(mainAction.actionList) && mainAction.actionList.length) {
        for (const subAction of mainAction.actionList) {
          if (subAction.permissionId === 'OI.PATIENT.ANALYTICS.READ') {
            subAction.enable = isActionEnable;
            mainAction.actionList = [ ...mainAction.actionList ];

            return;
          }
        }
      }
    }
  }

  factorDropDownMenuAction(actionKey: string): any {
    actionKey = actionKey.toLowerCase();

    if (actionKey === 'showpatientanalytics') {
      return this.showPatientAnalytics;
    } else if (actionKey === 'showform') {
      return this.showFrom;
    }
  }

  showPatientAnalytics(): void {
    this.router.navigate(['PatientAnalytics'], { queryParams: {
        patientId: this.routerManagerService.parameters.patientId
      }
    });
  }

  showFrom(payload: any): void{
    //Show a modal form according to test configuration
    if (!payload && payload.formId){
      console.warn('factorDropDownMenuAction -> showform: no payload.formId was found');
      return;
    }

    this.formHandler.popupDynamicFormModal(
      payload.title,
      payload.formId,
      {},
      payload.approve,
      payload.decline
    )
      .take(1)
      .subscribe(() => {});
  }

  reassignIsEnabled(): boolean {
    return this.reassignModalService.reassignIsEnabled(this.readOnlyParameters);
  }
}
